import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { KimRatingGridItemFragmentDoc } from '@packages/gql/generated/shopping/KimRatingGridItemFragmentDoc';
import { ErrorBoundary, Grid, KimRating } from '@packages/shared';

/* GraphQL */ `
  fragment KimRatingGridItem on Product {
    defaultCategory
    marketcode
  }
`;

export type KimRatingProps = {
  productData: FragmentType<typeof KimRatingGridItemFragmentDoc>;
  referer?: string;
};

export const KimRatingGridItem = ({ productData, referer }: KimRatingProps) => {
  const { defaultCategory, marketcode } = getFragmentData(
    KimRatingGridItemFragmentDoc,
    productData,
  );

  return (
    <ErrorBoundary>
      <Grid item xs={12}>
        <KimRating
          pageType="detailpage"
          templateParams={{
            x16: `${marketcode ?? 'x'}`,
            x17: referer ?? 'x',
            x19: defaultCategory ?? 'x',
          }}
        />
      </Grid>
    </ErrorBoundary>
  );
};
